// House of Lili おそろい診断（Phase 3 オリジナル機能）
// document への委譲でイベントを張るため、セクションのモーフィング（再描画）後も動作する。
if (!window.__holFamilySizeMatcherInit) {
  window.__holFamilySizeMatcherInit = true;

  // 英字サイズ → 身長(cm)の目安。数値サイズ（80〜140等）はそのまま身長として扱う。
  const ALPHA_SIZE_HEIGHTS = {
    XXS: 142,
    XS: 148,
    S: 155,
    M: 163,
    L: 171,
    XL: 179,
    XXL: 186,
    '2XL': 186,
    XXXL: 192,
    '3XL': 192,
    F: 163,
    FREE: 163,
    'フリー': 163,
    'フリーサイズ': 163,
  };
  const NUMERIC_TOLERANCE = 15; // 数値サイズで許容する身長との差(cm)
  const MAX_PEOPLE = 4;

  const routeRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const parseVariants = (root) => {
    try {
      return JSON.parse(root.querySelector('[data-fsm-variants]')?.textContent || '[]');
    } catch {
      return [];
    }
  };

  const sizeHeight = (label) => {
    const n = parseInt(label, 10);
    if (!Number.isNaN(n)) return { cm: n, numeric: true };
    const key = String(label).trim().toUpperCase();
    if (Object.prototype.hasOwnProperty.call(ALPHA_SIZE_HEIGHTS, key)) {
      return { cm: ALPHA_SIZE_HEIGHTS[key], numeric: false };
    }
    return null;
  };

  // 商品フォームで選択中のバリエーションからカラーを特定する
  const activeColor = (variants) => {
    const input =
      document.querySelector('product-information form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input) {
      const match = variants.find((v) => String(v.id) === String(input.value));
      if (match && match.color) return match.color;
    }
    const firstAvailable = variants.find((v) => v.available && v.color);
    if (firstAvailable) return firstAvailable.color;
    return variants.length > 0 ? variants[0].color : null;
  };

  const uniqueSizes = (variants) => {
    const seen = new Map();
    for (const v of variants) {
      const parsed = sizeHeight(v.size);
      if (parsed && !seen.has(v.size)) seen.set(v.size, parsed);
    }
    return [...seen.entries()].map(([size, parsed]) => ({ size, cm: parsed.cm, numeric: parsed.numeric }));
  };

  const renumber = (root) => {
    root.querySelectorAll('[data-fsm-person-name]').forEach((el, i) => {
      el.textContent = `${i + 1}人目`;
    });
    const addBtn = root.querySelector('[data-fsm-add]');
    if (addBtn) addBtn.hidden = root.querySelectorAll('[data-fsm-height]').length >= MAX_PEOPLE;
  };

  const addPersonRow = (root) => {
    if (!root) return;
    const holder = root.querySelector('[data-fsm-people]');
    const template = root.querySelector('[data-fsm-person-template]');
    if (!holder || !template || holder.children.length >= MAX_PEOPLE) return;
    holder.appendChild(template.content.firstElementChild.cloneNode(true));
    renumber(root);
  };

  const update = (root) => {
    const variants = parseVariants(root);
    const sizes = uniqueSizes(variants);
    const color = activeColor(variants);
    const resultBox = root.querySelector('[data-fsm-result]');
    const list = root.querySelector('[data-fsm-result-list]');
    const colorNote = root.querySelector('[data-fsm-color-note]');
    const bulkBtn = root.querySelector('[data-fsm-bulk-add]');
    const status = root.querySelector('[data-fsm-status]');
    if (!resultBox || !list) return;

    const heights = [...root.querySelectorAll('[data-fsm-height]')]
      .map((input) => parseInt(input.value, 10))
      .filter((h) => !Number.isNaN(h) && h >= 40 && h <= 200);

    list.innerHTML = '';
    if (status) status.textContent = '';
    root.__fsmItems = [];

    if (heights.length === 0 || sizes.length === 0) {
      resultBox.hidden = true;
      return;
    }

    heights.forEach((height, i) => {
      let best = null;
      let bestDiff = Infinity;
      for (const s of sizes) {
        const diff = Math.abs(s.cm - height);
        // 同点のときは大きいサイズを優先（サイズガイドの「迷ったらワンサイズ上」に合わせる）
        if (diff < bestDiff || (diff === bestDiff && best && s.cm > best.cm)) {
          best = s;
          bestDiff = diff;
        }
      }

      const li = document.createElement('li');
      const name = `${i + 1}人目（${height}cm）`;

      if (!best || (best.numeric && bestDiff > NUMERIC_TOLERANCE)) {
        li.textContent = `${name}：ぴったり合うサイズのお取り扱いがありません`;
        li.classList.add('family-size-matcher__result-item--miss');
      } else {
        const variant = variants.find(
          (v) => v.size === best.size && (v.color == null || color == null || v.color === color)
        );
        if (variant && variant.available) {
          li.textContent = `${name}：${best.size} サイズがおすすめです`;
          root.__fsmItems.push(variant.id);
        } else {
          const otherColor = variants.find((v) => v.size === best.size && v.available);
          if (otherColor && otherColor.color) {
            li.textContent = `${name}：${best.size} サイズがおすすめです（選択中のカラーは在庫切れ・「${otherColor.color}」なら在庫があります）`;
          } else {
            li.textContent = `${name}：${best.size} サイズがおすすめです（現在在庫切れ）`;
          }
          li.classList.add('family-size-matcher__result-item--miss');
        }
      }
      list.appendChild(li);
    });

    if (colorNote) {
      if (color != null) {
        colorNote.hidden = false;
        colorNote.textContent = `カラー「${color}」でご提案しています。カラーを変えるときは、商品ページで色を選び直してから診断してください。`;
      } else {
        colorNote.hidden = true;
      }
    }
    if (bulkBtn) bulkBtn.disabled = root.__fsmItems.length === 0;
    resultBox.hidden = false;
  };

  const addAllToCart = async (root) => {
    if (!root) return;
    const ids = root.__fsmItems || [];
    const status = root.querySelector('[data-fsm-status]');
    const bulkBtn = root.querySelector('[data-fsm-bulk-add]');
    if (ids.length === 0) return;

    // 同じバリエーションが複数人分あるときは数量をまとめる
    const quantities = new Map();
    ids.forEach((id) => quantities.set(id, (quantities.get(id) || 0) + 1));
    const items = [...quantities.entries()].map(([id, quantity]) => ({ id, quantity }));

    if (bulkBtn) bulkBtn.disabled = true;
    if (status) status.textContent = 'カートに追加しています…';

    try {
      const res = await fetch(`${routeRoot()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error(`cart add failed: ${res.status}`);

      const cartRes = await fetch(`${routeRoot()}cart.js`);
      const cart = cartRes.ok ? await cartRes.json() : null;

      // テーマのカート更新イベント（assets/events.js の cart:update）を発火して
      // カートバッジ・送料無料バーなどを更新する
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'family-size-matcher',
            data: { source: 'family-size-matcher', itemCount: cart ? cart.item_count : undefined },
          },
        })
      );

      if (status) {
        status.textContent = '';
        status.append('カートに追加しました。');
        const link = document.createElement('a');
        link.href = `${routeRoot()}cart`;
        link.textContent = 'カートを見る';
        status.append(link);
      }
    } catch (error) {
      console.error('family-size-matcher:', error);
      if (status) status.textContent = 'カートへの追加に失敗しました。時間をおいて再度お試しください。';
      if (bulkBtn) bulkBtn.disabled = false;
    }
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-fsm-open]');
    if (opener) {
      const root = opener.closest('family-size-matcher');
      const dialog = root?.querySelector('[data-fsm-dialog]');
      if (root && dialog && typeof dialog.showModal === 'function' && !dialog.open) {
        if (root.querySelectorAll('[data-fsm-height]').length === 0) {
          addPersonRow(root);
          addPersonRow(root);
        }
        dialog.showModal();
      }
      return;
    }

    const closer = event.target.closest('[data-fsm-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    const adder = event.target.closest('[data-fsm-add]');
    if (adder) {
      addPersonRow(adder.closest('family-size-matcher'));
      return;
    }

    const bulk = event.target.closest('[data-fsm-bulk-add]');
    if (bulk) {
      addAllToCart(bulk.closest('family-size-matcher'));
      return;
    }

    // 背景（backdrop）クリックで閉じる
    const dialog = event.target.closest('dialog[data-fsm-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });

  document.addEventListener('input', (event) => {
    const target = event.target;
    if (target instanceof HTMLElement && target.matches('[data-fsm-height]')) {
      const root = target.closest('family-size-matcher');
      if (root) update(root);
    }
  });
}
